import React from 'react';

import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { ExportedPdfRowItem } from './types';
import { useExportedPdfActionItems } from './hooks/use-exported-pdf-action-items';

interface ExportedPdfActionsPopoverProps {
  item: ExportedPdfRowItem;
  onDelete: () => void;
}

/**
 * Actions popover menu for an exported PDF row.
 * Renders a tertiary button that opens a context menu with view, download, and management actions.
 *
 * @param props.item - The exported or dispatched report row item.
 * @param props.onDelete - Callback to trigger the delete dialog.
 */
export const ExportedPdfActionsPopover = ({ item, onDelete }: ExportedPdfActionsPopoverProps) => {
  const items = useExportedPdfActionItems({ item, onDelete });

  return <ListingPageRowActions items={items} />;
};
